<div class="modal-content">
  <div class="modal-header text-center">
    <span class="modal-encontrar-cep__title">Não sei o CEP</span>
  </div>
  <div class="modal-body">
    <form class="forms" [formGroup]="formEncontrarCep">
      <div class="row">
        <div class="form-group">
          <div class="inputs modal-encontrar-cep__field">
            <label for="endereco">Endereço</label>
            <input
              type="text"
              class="form-control"
              id="endereco"
              name="endereco"
              formControlName="endereco"
              placeholder="Digite o endereço sem o logradouro (rua, av, vila, etc...)"
              maxlength="150"
              appShowErrorMessages
              uppercase
              required
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group">
          <div class="inputs modal-encontrar-cep__field">
            <label for="bairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              id="bairro"
              name="bairro"
              formControlName="bairro"
              placeholder="Bairro"
              maxlength="150"
              appShowErrorMessages
              uppercase
              appOnlyLetter
            />
          </div>
        </div>
      </div>

      <div class="row modal-encontrar-cep__group">
        <div class="col-xs-4 padding0">
          <label for="uf">UF</label>
          <select 
            (change)="onChangeUf()" 
            class="form-control" 
            formControlName="uf" 
            id="uf" 
            name="uf" 
            appShowErrorMessages 
            [disabled]="isBuscandoCidade">
            <option value="" selected disabled>Selecione...</option>
            <option *ngFor="let uf of ufs" value="{{ uf.codigo }}">{{ uf.codigo }}</option>
          </select>
        </div>
      
        <div [ngSwitch]="isBuscandoCidade" class="col-xs-8">
          <label for="cidade">Cidade</label>
          <select 
            *ngSwitchDefault 
            class="form-control" 
            formControlName="cidade" 
            id="cidade" 
            name="cidade" 
            appShowErrorMessages>
            <option value="" selected disabled>Selecione...</option>
            <option *ngFor="let cidade of cidades" value="{{ cidade }}">{{ cidade }}</option>
          </select>
          <app-loader-default *ngSwitchCase="true"></app-loader-default>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="modal-encontrar-cep__action">
      <button 
        type="button" 
        class="btn btn-app btn-secondary" 
        (click)="close()">
        Cancelar
      </button>
      
      <button 
        type="button" 
        class="btn btn-app btn-primary" 
        [disabled]="formEncontrarCep.invalid" 
        (click)="onClickConfirmar()">
        Confirmar
      </button>
    </div>
  </div>
</div>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>

<app-new-modal-message #cepInvalidoModal [showFecharBtn]="false"></app-new-modal-message>